import React, { memo } from 'react'
import { BodyText, HeadingText, Link } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { NOTIFICSTION_SETTINGS } from '../../constants/constants'

const MarketingPreferences = memo((props) => (
  <div className="privacyHub-model">
    <HeadingText
      id="marketingPrefsHeader"
      className="privacyHub-model-heading"
      size="lg"
    >
      <Message id="privacyhub.marketingpreferences.header" />
    </HeadingText>
    <BodyText className="privacyHub-model-content">
      <Message
        id="privacyhub.marketingpreferences.component.desc"
        link={(innerMessage) => (
          <Link
            id="notificationSettingsLink"
            name="notification_settings"
            href={NOTIFICSTION_SETTINGS}
          >
            {innerMessage}
          </Link>
        )}
      />
    </BodyText>
    <BodyText className="privacyHub-model-content">
      <Message id="privacyhub.marketingpreferences.component.content" />
    </BodyText>

    {props.content(props.keys && props.keys.marketingprefs)}
  </div>
))

MarketingPreferences.displayName = 'MarketingPreferences'

export default MarketingPreferences
